<div class="app-spacer" [style.margin-top]="getMarginTop()" [style.margin-right]="getMarginRight()"
  [style.margin-bottom]="getMarginBottom()" [style.margin-left]="getMarginLeft()">
</div>
